import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import Cart from "./Cart";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import CheckedLoggedInModal from "./CheckLoggedInModal";
import toast from "react-hot-toast";
import about1 from "../../assets/images/about1.png";
import "./cart.css";
import {
  AuthContextProvider,
  LoaderContext,
} from "../../AuthContext/AuthContext";
import LoginPopUp from "../LoginPopup";
import { Tooltip } from "@mui/material";
import { GetProductDetailsBySlug } from "../../ApiServices/SlugsApi/GetProductDetailsBySlugApi";
import { Helmet } from "react-helmet-async";
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import OwlCarousel from "react-owl-carousel3";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import { GetFAQListByService } from "../../ApiServices/FAQ/FAQApi";
import { FaqModuleID, pujaServiceID, pujaSubServiceID } from "../enum";
import ShareLinkModal from "../ShareLinkModal";
import { AddUpdateRemoveCart, GetPopolarProductList, ProductDetailsBySlug } from "../../ApiServices/EStore/EStoreApi";
import HoroscopeBannerImg from "../../assets/images/new/banner-remid.jpeg";
import PopularProducts from "../CommonSections/PopularProducts";
import PujaPageSections from "../../Pages/RemedyPuja/PujaTabs";
import LazySection from "../../Pages/Home/LazySection";
import HowItWorks from "../CommonSections/HowItWorks";
import DownloadApp from "../DownLoadApp/DownloadApp";

import { Container, Row, Col, Card, Button, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from "i18next";
import { faShareAlt } from "@fortawesome/free-solid-svg-icons"; // or faShareNodes if you prefer newer icon
import ProductTabsSection from "../CommonSections/ProductTabsSection";
import Breadcrumbs from "../Breadcrumb";
import { GetPopolarPujaList } from "../../ApiServices/Puja/PujaApi";
import SankalpPujasPackageList from "../../Pages/SankalpPujas/SankalpPujasPackageList";

const Cart = () => {
  const data = localStorage.getItem("userID");
  const userKeyID = localStorage.getItem("userKeyID");
  const [totalRecords, setTotalRecords] = useState(-1);


  const [loginPopUp, setLoginPopUp] = useState(false);
  const { isAuthenticated } = useContext(AuthContextProvider);
  const { slug } = useParams();
  const [showModal, setShowModal] = useState(false);
  const currentUrl = window.location.href;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);
  const [FAQ, setFaq] = useState([]);
  const [inputValue, setInputValue] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  const ItemAddedToast = () => toast.success("Item added successfully");
  const [images, setImages] = useState([]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const CatID = location?.state?.catId;

  const [productDetailsData, setProductDetailsData] = useState({
    productID: null,
    productKeyID: null,
    productName: null,
    productPrice: null,
    DISCOUNT: null,
    unitID: 1,
    productDescription: null,
    productSpecification: null,
    unit: null,
    productCategoryID: 1,
    productCategoryName: null,
    discount: null,
    CART_ID: 2,
    QUANTITY: null,
    discountAmtount: 102,
    length: null,
    height: null,
    width: null,
    weight: null,
    productImageURL: [],
    productSlug: null,
    metaTitle: null,
    metaDescription: null,
    openGraphtag: null,
    canonicalTag: null,
    extraMetaTag: null,
    shortDescription: null,
    keyFeature: null,
    cartQuantity: 0,
    productCatKeyID: null
  });
  const { setLoader, setIsCartUpdate, isCartUpdate, selectedLanguageID, formatToIndianCurrency } = useContext(LoaderContext);
  const [popularProductList, setPopularProductList] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState({})
  const [showLoginModal, setShowLoginModal] = useState(null);
  // ----------------------------------
  const [mainImage, setMainImage] = useState(null);
  const [readMore, setReadMore] = useState(false);
  const [deityReadMore, setDeityReadMore] = useState(false);
  const [readMoreDetailed, setReadMoreDetailed] = useState(false);
  const maxChars = 1000; // number of characters to show initially
  const DeityChars = 80; // number of characters to show initially

  useEffect(() => {
    GetProductDetailsBySlugData();
  }, []);

  useEffect(() => {
    GetProductDetailsBySlugData();
  }, [location, selectedLanguageID, isCartUpdate]);

  useEffect(() => {

    if (isAuthenticated) {

      if ((selectedPackage?.price !== undefined && selectedPackage?.price !== null)) {
        handleProceedToBookClicked()
      }
    } else if (productDetailsData?.isSubscriptionProductCategory) {
      setLoginPopUp(true)
    }
  }, [selectedPackage])

  const GetTrendingProducts = async (catId, productID) => {
    setLoader(true);
    try {
      const response = await GetPopolarProductList(selectedLanguageID, productDetailsData?.productCatKeyID, location?.state?.templeKeyID);
      if (response?.statusCode === 200) {
        const data = response?.responseData?.data;
        setLoader(false);
        setPopularProductList(data);
      }


    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (images?.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % images?.length);
      }, 5000); // 5 seconds

      return () => clearInterval(interval); // Clear on unmount
    }
  }, [images?.length]);



  const handleProceedToBookClicked = () => {

    const userKeyID = localStorage.getItem("userKeyID")
    if (userKeyID !== null && userKeyID !== undefined && userKeyID !== "") {

      let updatedProductDetailsData = {
        ...productDetailsData,

      };


      updatedProductDetailsData = {
        ...productDetailsData,
        pujaKitPrice: selectedPackage?.price,
        discountedAmount: selectedPackage?.discountedAmount || 0,

        discount: selectedPackage?.discount,
        pujaTypeID: 2,
        title: selectedPackage?.title,
        subTitle: selectedPackage?.subTitle,
        timeLine: selectedPackage?.timeLine,
        description: selectedPackage?.description,
        pujaSubServiceID: pujaSubServiceID?.Product,
        pujaServiceID: pujaServiceID?.Ecommerce,
        pSubPlanKeyID: selectedPackage?.pSubPlanKeyID
      };




      setShowLoginModal(false);
      navigate("/puja-kit-booking", {
        state: {

          productDetailsData: updatedProductDetailsData,

        },
      });
    } else {
      setShowLoginModal(true);
    }
  };



  const GetProductDetailsBySlugData = async () => {

    setLoader(true);
    try {
      const response = await ProductDetailsBySlug({
        productSlug: slug,
        applangID: selectedLanguageID,
        userKeyID: userKeyID
      });

      if (response?.statusCode === 200) {
        const modalData = response?.responseData?.data
        setLoader(false);


        setProductDetailsData(modalData);
        GetTrendingProducts(modalData?.productCategoryID, modalData?.productID);
        GetFAQListByServiceData(modalData?.productID);
        setImages(modalData?.productImageURL);
        setTotalRecords(modalData ? 1 : 0);

      } else {
        setLoader(false);
        setTotalRecords(0);
      }


    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const GetFAQListByServiceData = async (productID) => {

    setLoader(true);
    try {
      const response = await GetFAQListByService(
        FaqModuleID?.EstoreBooking,
        productID
      );

      if (response) {
        setLoader(false);
        const modalData = response.DATA;

        setFaq(modalData);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? images?.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === images?.length - 1 ? 0 : prev + 1));
  };

  const addProduct = async (product, action) => {

    if (!isAuthenticated) {
      setLoginPopUp(true)
    } else {
      setLoader(true);
      try {
        const response = await AddUpdateRemoveCart({
          cartKeyID: product?.cartKeyID,
          productKeyID: product?.productKeyID,
          userKeyID: userKeyID,
          action: action
        });

        if (response?.statusCode === 200) {
          setLoader(false);
          if (product?.cartQuantity === 0) {
            toast.success("Product Added to cart.")
          }


          setIsCartUpdate(true)

        } else {
          setLoader(false);

        }


      } catch (error) {
        setLoader(false);
        console.log(error);
      }
    }

  }


  const handleNavigation = (slug) => {

    navigate(`/product-details/${slug}`);

  };
  const options = {
    loop: popularProductList?.length > 3,
    rewind: true, // Enable rewind instead of looping
    margin: 30,
    nav: true,
    dots: false,
    autoplay: false,
    autoplayTimeout: 3000,
    smartSpeed: 800,
    navText: [
      "<i class='fas fa-arrow-left'></i>",
      "<i class='fas fa-arrow-right'></i>",
    ],
    responsive: {
      0: {
        items: 1, // 1 item on small screens
      },
      600: {
        items: 2, // 2 items on medium screens
      },
      1000: {
        items: 3, // 3 items on large screens
      },
    },
  };

  const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.innerText || tempDiv.textContent || "";
  };



  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": productDetailsData?.metaTitle,
    "description": productDetailsData?.metaDescription,
    "image": productDetailsData?.imageURL || "default-image-url.jpg",
    "author": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": "https://www.myomnamo.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.myomnamo.com"
      }
    },
    "datePublished": productDetailsData?.publishedDate || null,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": productDetailsData?.canonicalTag
    }
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": productDetailsData?.metaTitle,
    "description": productDetailsData?.metaDescription,
    "url": productDetailsData?.canonicalTag,
    "image": productDetailsData?.imageURL || "default-image-url.jpg",
    "inLanguage": "en",
    "publisher": {
      "@type": "Organization",
      "name": "Myomnamo",
      "url": "https://www.myomnamo.com"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.myomnamo.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Products",
        "item": "https://www.myomnamo.com/my-store"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": productDetailsData?.metaTitle,
        "item": productDetailsData?.canonicalTag
      }
    ]
  };

  const productSchema = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": productDetailsData.productName,
    "image": (images?.length > 0) ? images[0] : null,
    "description": productDetailsData?.shortDescription,
    "brand": {
      "@type": "Brand",
      "name": "Myomnamo"
    },
    "sku": "",
    "offers": {
      "@type": "Offer",
      "url": `https://www.myomnamo.com/product-details/${productDetailsData?.ProductSlug}`,
      "priceCurrency": "INR",
      "price": productDetailsData?.productPrice,
      "availability": "https://schema.org/InStock",
      "itemCondition": "https://schema.org/NewCondition"
    }

  }

  // ------------------------------------------------------
  const toggleReadMore = () => setReadMore(!readMore);
  const toggleDeityReadMore = () => setDeityReadMore(!deityReadMore);
  const toggleReadMoreDetails = () => setReadMoreDetailed(!readMoreDetailed);

  const plainText = (() => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = productDetailsData.shortDescription;
    return tempDiv.innerText || tempDiv.textContent || "";
  })();


  const howItWorks = [
    {
      howItWorksTitle: "Select Your Homam Puja",
      howItWorksDesc:
        "Choose the Homam Puja you wish to perform, be it for peace, prosperity, health, housewarming, or any special occasion.",
    },
    {
      howItWorksTitle: "Book Your Ritual Easily",
      howItWorksDesc:
        "Simply book your puja, and our experienced priests will conduct every ritual with devotion and authentic Vedic tradition.",
    },
    {
      howItWorksTitle: "Receive Divine Blessings",
      howItWorksDesc:
        "Join the sacred ceremony, feel the positive vibrations, and invite blessings of health, happiness, and prosperity into your life.",
    },
  ]


  return (
    <>

      <Helmet>
        <title>{productDetailsData?.metaTitle}</title>
        <meta
          name="description"
          content={productDetailsData?.metaDescription}
        />
        <link rel="canonical" href={productDetailsData?.canonicalTag} />

        {/* Open Graph Tag */}

        {/* <!-- Open Graph tags --> */}
        <meta property="og:title" content={productDetailsData?.metaTitle} />
        <meta
          property="og:description"
          content={productDetailsData?.metaDescription}
        />
        <meta property="og:image" content="" />
        <meta
          property="og:url"
          content={`https://www.myomnamo.com/product-details/${productDetailsData?.productSlug}`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Myomnamo" />
        <meta property="og:locale" content="en_IN" />

        {/* <!-- Twitter Card tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={productDetailsData?.metaTitle} />
        <meta
          name="twitter:description"
          content={productDetailsData?.metaDescription}
        />
        <meta name="twitter:image" content="" />
        {productDetailsData?.extraMetaTag}

        {/* Breadcrumb JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>

        {/* WebPage JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(webPageSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(articleSchema)}
        </script>

        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      <section className="page-header" style={{ paddingBottom: '28px' }}>
        <div
          className="page-header__bg horoscope-banner-responsive"
          style={{ backgroundImage: `url(${HoroscopeBannerImg})` }}
        ></div>
        <div className="container" style={{ display: 'block' }}>
          <h2 className="page-header__title bw-split-in-left">{t("Product Details")}</h2>
          <div className="d-flex justify-content-center">
            <Breadcrumbs />
          </div>
        </div>
      </section>

      {totalRecords > 0 && (
        <>

          <Container fluid className='pooja-remidy mt-60' style={{ maxWidth: "1200px" }} >


            {/* Main Content Row */}
            <Row className="justify-content-center mt-3">
              {/* Left Column: Image Gallery */}
              <div className="col-md-5 mb-3" style={{ maxHeight: '55vh' }}>
                <div
                  className="slider-container mb-2"
                  style={{ overflow: "hidden", width: "100%", maxHeight: '50vh' }}
                >
                  <div
                    className="slider-wrapper"
                    style={{
                      display: "flex",
                      transition: "transform 0.5s ease-in-out",
                      transform: `translateX(-${currentIndex * 100}%)`,
                      height: "100%",
                    }}
                  >
                    {images.map((image, index) => (
                      <img
                        key={index}
                        src={image || placeholderImg}
                        alt={`Image ${index + 1}`}
                        className="img-fluid rounded"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = placeholderImg;
                        }}
                        style={{
                          width: "100%",
                          height: "80%",
                          objectFit: "contain",
                          flexShrink: 0,
                        }}
                      />
                    ))
                    }
                  </div>
                </div>
                {images?.length > 1 && (
                  <div className=" d-flex gap-3 justify-content-center">
                    <Tooltip title="Previous Image">
                      <button
                        className="input-group-text text-white"
                        style={{ backgroundColor: "#a52444" }}
                        onClick={handlePrev}
                      >
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                      </button>
                    </Tooltip>
                    <Tooltip title="Next Image">
                      <button
                        className="input-group-text text-white"
                        style={{ backgroundColor: "#a52444" }}
                        onClick={handleNext}
                      >
                        <i class="fa fa-arrow-right" aria-hidden="true"></i>
                      </button>
                    </Tooltip>
                  </div>
                )}
              </div>


              {/* Right Column: Puja Details */}
              <Col md={6} className=" mt-md-0">
                <div className=" h-100">
                  {/* Header */}
                  {/* <div className="text-center py-2 seatsLeft">
                                    <p className="mb-0 fw-bold text-muted">Last day today!</p>
                                </div> */}
                  <div className=" px-md-4">
                    {/* Title and Subtitle */}
                    <h4 className="mb-1 fw-bold">{productDetailsData?.productName}</h4>


                    {(productDetailsData?.isSubscriptionProductCategory === null || !productDetailsData?.isSubscriptionProductCategory) && (

                      <div className="price-tag  position-relative align-items-start mb-1 mt-1">

                        <div className="text-dark px-3  rounded" style={{ background: "#efb423", marginRight: "10px" }}>
                          <strong>
                            ₹{" "}
                            {productDetailsData.discountedAmount
                              && formatToIndianCurrency(Math.round(productDetailsData.discountedAmount))}
                          </strong>


                        </div>
                        {productDetailsData?.discount !== null &&
                          productDetailsData?.discount !== undefined &&
                          productDetailsData?.discount > 0 ? (
                          <>
                            <span className="original-price">
                              ₹ {formatToIndianCurrency(Math.round(productDetailsData.productPrice))}
                            </span>
                            <span className="discount-text">
                              ({Math.round(Number(productDetailsData.discount))}% {t("OFF")})
                            </span>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                    <div className="my-2">
                      {productDetailsData?.length && (
                        <span
                          className="ms-auto mx-2 d-inline-flex align-items-center justify-content-center px-2 rounded"
                          style={{
                            backgroundColor: "#fff7e6", // soft yellow background
                            border: "1px solid #f4b722",
                            borderRadius: "6px",
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#000",
                            minWidth: "45px",
                          }}
                        >

                          {t("Length")} : {productDetailsData?.length}
                        </span>
                      )}

                      {productDetailsData?.height && (
                        <span
                          className="ms-auto mx-2 d-inline-flex align-items-center justify-content-center px-2 rounded"
                          style={{
                            backgroundColor: "#fff7e6", // soft yellow background
                            border: "1px solid #f4b722",
                            borderRadius: "6px",
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#000",
                            minWidth: "45px",
                          }}
                        >

                          {t("Height")} : {productDetailsData?.height}
                        </span>
                      )}

                      {productDetailsData?.width && (
                        <span
                          className="ms-auto mx-2 d-inline-flex align-items-center justify-content-center px-2 rounded"
                          style={{
                            backgroundColor: "#fff7e6", // soft yellow background
                            border: "1px solid #f4b722",
                            borderRadius: "6px",
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#000",
                            minWidth: "45px",
                          }}
                        >

                          {t("Width")} : {productDetailsData?.width}
                        </span>
                      )}
                      {productDetailsData?.weight && (
                        <span
                          className="ms-auto mx-2 d-inline-flex align-items-center justify-content-center px-2 rounded"
                          style={{
                            backgroundColor: "#fff7e6", // soft yellow background
                            border: "1px solid #f4b722",
                            borderRadius: "6px",
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#000",
                            minWidth: "45px",
                          }}
                        >

                          {t("Weight")} : {productDetailsData?.weight}
                        </span>
                      )}
                    </div>




                    {/* Short Description */}
                    {productDetailsData?.shortDescription !== null && productDetailsData?.shortDescription !== undefined && (
                      <p className="small" style={{ marginBottom: "2px" }}>
                        {readMore ? plainText : plainText?.length > maxChars ? `${plainText.substring(0, maxChars)}...` : plainText}
                        {plainText?.length > maxChars && (
                          <span
                            onClick={toggleReadMore}
                            // className="btn-fancy"
                            style={{ color: '#a52444', cursor: 'pointer' }}
                          >
                            {readMore ? t("...Read Less") : t("Read More")}
                          </span>
                        )}
                      </p>
                    )}


                    {/* Participate Button */}

                    <div className='d-flex justify-content-between'>
                      {(productDetailsData?.isSubscriptionProductCategory === null || !productDetailsData?.isSubscriptionProductCategory) && (
                        <>
                          {productDetailsData?.cartQuantity > 0 ? (
                            <div
                              className="d-flex justify-content-between  align-items-center mt-2 qty-container"
                              style={{ width: "80%" }}
                            >
                              <button
                                onClick={() => addProduct(productDetailsData, 'Update')}
                                className="product-qty"
                              >
                                −
                              </button>
                              <span
                                className="quantity"
                              >
                                {productDetailsData.cartQuantity}
                              </span>
                              <button
                                onClick={() => addProduct(productDetailsData, "Add")}
                                className="product-qty"
                              >
                                +
                              </button>
                            </div>
                          ) : (
                            <Button
                              onClick={() => addProduct(productDetailsData, "Add")}

                              size='lg'
                              className="w-50 z-100 rounded-pill  py-1 mt-1 pulse-button  mb-2"
                            >
                              {t("Add To Cart")}
                            </Button>

                          )}
                        </>
                      )}



                      <div className="d-flex align-items-end gap-2">


                        {/* Share Button */}
                        <Button
                          className="icon-btn share-btn" style={{ height: "45px" }}
                          onClick={() => {
                            if (navigator.share) {
                              navigator.share({
                                title: productDetailsData?.productName,
                                text: productDetailsData?.shortDescription || '',
                                url: window.location.href,
                              });
                            } else {
                              alert("Sharing not supported on this device");
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faShareAlt} />
                        </Button>
                      </div>
                    </div>






                  </div>
                </div>
              </Col>
            </Row>

            {(productDetailsData?.isSubscriptionProductCategory) && (
              <>
                <hr />
                <SankalpPujasPackageList serviceName={"Puja Kit Subscription"} pujaKeyID={productDetailsData?.productKeyID} setSelectedPackage={setSelectedPackage} isSubscriptionProductCategory={true} />
              </>
            )}

            {/* Tabs Wise Details */}
            <Row>
              <LazySection><ProductTabsSection productDetailsData={productDetailsData} FAQ={FAQ} t={t} /></LazySection>
            </Row>

            {/* How it Works */}
            {/* <Row>
              <LazySection><HowItWorks serviceData={howItWorks} /></LazySection>
            </Row> */}
            {popularProductList?.length > 0 && (

              <PopularProducts productList={popularProductList} />
            )}
          </Container >
          <LazySection> <DownloadApp languageID={selectedLanguageID == 3 ? 1 : null} /></LazySection>
        </>
      )}



      {loginPopUp && (
        <LoginPopUp show={loginPopUp} onHide={() => setLoginPopUp(false)} />
      )}
      <ShareLinkModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        shareUrl={currentUrl}
        message="Hey! Have a look at this amazing content." // Optional
        title="Spread the word" // Optional
      />

    </>
  );
};

export default Cart;
